/**
 * Компактная метка канала: Telegram или MAX (поле messenger из API).
 */
export function MessengerBadge({ messenger, className = "" }) {
  const m = String(messenger || "telegram").toLowerCase();
  const isMax = m === "max";
  const label = isMax ? "MAX" : "TG";
  const tip = isMax ? "Клиент в MAX" : "Клиент в Telegram";
  return (
    <span
      className={`messengerBadge ${isMax ? "messengerBadgeMax" : "messengerBadgeTg"} ${className}`.trim()}
      title={tip}
    >
      {label}
    </span>
  );
}
